import React from 'react';
import * as $ from 'jquery';
import useHttp from '../../../hook/use-http';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { INDEX } from '../../../constants/driveglobalfilterinitalstates_kratos';
import CustomSelect_Kratos from '../Charginganalysis_Kratos/CustomSelect_Kratos';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../redux/cityDepoSlice';

export default function Charging_Filters_Kratos(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  const [changedColumn, setChangedColumn] = useState("");
  const [columnfilters, setcolumnfilters] = useState([]);
  const [singleBtn, setsingleBtn] = useState(false);

  // code to get city_depo from redux
  const [userCityDepo, setUserCityDepo] = useState({})
  const cityDepoAccess = useSelector(selectCityDepo);
  // code to get city_depo from redux

  const inputElement = useRef();
  const filterHideShow = () => {
    $("#filterSearch").toggle("slow");
  }

  const [refreshDate, setRefreshDate] = useState("")
  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "critical_vehicles_kratos/critical_vehicle_refreshdate_bus", body: {} }, refreshDateData)
    if (props.gloablfilter.DEPO.length > 0) {
      setcolumnfilters([...columnfilters, "DEPO_INDEX"])
    }
    setUserCityDepo(cityDepoAccess)
  }, [])

  useEffect(() => {
    if (props.gloablfilter.VIN_NUM.length === 1) {
      setToHIdeShowRCA("d-inline-block")
      setToSendChasisRCA(props.fromTableToFilter_vin)
    }
  }, [props])

  const refreshDateData = (data) => {
    setRefreshDate(data.value_as_string);
  }

  const updateFilter = (arr, index) => {
    let state_ind = INDEX[index];
    setFilterData((prestate) => { return { ...filterdata, [state_ind]: arr } })
    setChangedColumn(index);
    if (columnfilters.indexOf(index) == -1) {
      setcolumnfilters([...columnfilters, index]);
    }
  }

  const vinnumChanged = (e) => {
    let enterter_vin = e.target.value;
    if (enterter_vin != "") {
      let new_vin = enterter_vin.split(",");
      if (new_vin.length == 1) {
        setsingleBtn(true);
      }
      setChangedColumn("VIN_NUM");
      let VIN_NUM = "VIN_NUM";
      setFilterData((prestate) => { return { ...filterdata, VIN_NUM: new_vin } })
      if (columnfilters.indexOf("VIN_NUM") == -1) {
        setcolumnfilters([...columnfilters, "VIN_NUM"]);
      }
    }
  }

  const startDateChanged = (date) => {
    let sDate = "startDate";
    setChangedColumn("startDate");
    setFilterData((prestate) => { return { ...filterdata, [sDate]: date } })
    if (columnfilters.indexOf("START_DATE") == -1) {
      setcolumnfilters([...columnfilters, "START_DATE"]);
    }
  }

  const endDateChanged = (date) => {
    let eDate = "endDate";
    setChangedColumn("endDate");
    setFilterData((prestate) => { return { ...filterdata, [eDate]: date } })
    if (columnfilters.indexOf("END_DATE") == -1) {
      setcolumnfilters([...columnfilters, "END_DATE"]);
    }
  }

  const [toHIdeShowRCA, setToHIdeShowRCA] = useState("d-none")
  const [toSendChasisRCA, setToSendChasisRCA] = useState(0)
  const [depoErrMsg, setDepoErrMsg] = useState("")
  const onsubmit = (e) => {
    setDepoErrMsg("")
    e.preventDefault();
    if (userCityDepo.depot.length === 0) {
      if (filterdata.VIN_NUM.length === 1) {
        setToHIdeShowRCA("d-inline-block")
        setToSendChasisRCA(filterdata.VIN_NUM[0])
      }
      props.onsubmit(filterdata);
    } else {
      if (filterdata.DEPO.length === 0) {
        setDepoErrMsg("Please select at least 1 depot")
      } else {
        if (filterdata.VIN_NUM.length === 1) {
          setToHIdeShowRCA("d-inline-block")
          setToSendChasisRCA(filterdata.VIN_NUM[0])
        }
        props.onsubmit(filterdata);
      }
    }
  }
  const onreset = (e) => {
    window.location.reload(true);
  }

  return (
    <>
      <div className="container-fluid pt-3 cardBox">
        <div className="card">
          <div className="card-body kratosflt">
            <div className="row d-flex justify-content-between">
              <div className="col-lg-3 col-sm-3 d-flex align-items-center">
                <p className="small mb-0">Last Refresh Date: {refreshDate}</p>
              </div>
              <div className="col-lg-7 col-sm-7 d-flex align-items-center justify-content-center">
                <h5 className="mb-0 font-kratos-head">Critical Vehicles</h5>
              </div>

              <div className="col-lg-2 col-sm-2 text-end filter_kratos_icon_f">
                {/* <div className={`text-start mr-1 rca_btn ${toHIdeShowRCA}`}>
                  <Link to={`/dashboard_kratos/rca_kratos/${toSendChasisRCA}`}>
                    <button type="button" className="btn text-white rca_btn_kratos"><i className="fa fa-cogs"></i><b>&nbsp;&nbsp;RCA</b></button>
                  </Link>
                </div> */}
                <div className="text-end d-inline-block">
                  <button type="button" id="filterIcon" onClick={filterHideShow} className="btn btn-sm btn-outline-primary material-icons filter_kratos_icon">filter_alt</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="FilterDiv_kratos p-2 mb-3" id="filterSearch" style={{ display: 'none', zIndex: 1 }}>
          <form className="g-3 mt-2 filterForm">
            <div className="row">
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label_kratos">Start Date</label>
                  <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.startDate} onChange={startDateChanged} />
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput2" className="form-label_kratos">End Date</label>
                  <DatePicker dateFormat="dd-MM-yyyy" minDate={moment(new Date("2023-08-15T00:00:00.000Z")).toDate()} maxDate={moment().subtract(1, "days").toDate()} selected={filterdata.endDate} onChange={endDateChanged} />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlInput2" className="form-label_kratos">Chassis No / Reg No</label>
                  <input autoComplete="off" defaultValue={filterdata.VIN_NUM.join(",")} className="top-filter filter-col" placeholder="Chassis No / Reg No" id="vin_num" ref={inputElement} onBlur={vinnumChanged} />
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="CITY" IND="CITY_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Kratos>
                </div>
              </div>
              {/* <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="DEPOT" IND="DEPO_INDEX" updateFilter={updateFilter} cty_depo="true" ></CustomSelect_Kratos>
                  <p className="text-danger text-center" style={{ fontSize: "12px" }}><b>{depoErrMsg}</b></p>
                </div>
              </div> */}
            </div>
            <div className="row">
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="LOB" IND="LOB_INDEX" updateFilter={updateFilter}></CustomSelect_Kratos>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PPL" IND="PPL_INDEX" updateFilter={updateFilter}></CustomSelect_Kratos>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="PL" IND="PL_INDEX" updateFilter={updateFilter}></CustomSelect_Kratos>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="mb-3">
                  <CustomSelect_Kratos columnfilters={columnfilters} changedColumn={changedColumn} filterdata={filterdata} lable="AC Type" IND="AIR_VENTILATION_INDEX" updateFilter={updateFilter}></CustomSelect_Kratos>
                </div>
              </div>
              <div className="col-lg-1 col-md-6 col-sm-12 kratos_filtr_btn filter_kratos_icon_f">
                <div className="mt-2">
                  <label className="form-label_kratos" />
                  <button type="submit" className="form-control btn btn_kratos btn-primary" onClick={onsubmit}>Search</button>
                </div>
              </div>
              <div className="col-lg-1 col-md-6 col-sm-12 kratos_filtr_btn filter_kratos_icon_f">
                <div className="mt-2">
                  <label className="form-label_kratos" />
                  <Link>
                    <button type="button" className="form-control btn btn-secondary" onClick={onreset}>Reset</button>
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}